import { render, staticRenderFns } from "./DataSelect.vue?vue&type=template&id=5a7e872a&"
import script from "./DataSelect.vue?vue&type=script&lang=js&"
export * from "./DataSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7e872a')) {
      api.createRecord('5a7e872a', component.options)
    } else {
      api.reload('5a7e872a', component.options)
    }
    module.hot.accept("./DataSelect.vue?vue&type=template&id=5a7e872a&", function () {
      api.rerender('5a7e872a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DataSelect.vue"
export default component.exports